export enum ResourcePageRouteId {
  Forms = 'FormsGuides',
  Tools = 'ToolsCalculators'
}